"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getActiveElement;
function getActiveElement(rootEl) {
  var activeEl = (rootEl !== null && rootEl !== void 0 ? rootEl : document).activeElement;
  if (activeEl !== null && activeEl !== void 0 && activeEl.shadowRoot) {
    return getActiveElement(activeEl.shadowRoot);
  }
  return activeEl;
}